/**
 * Created by YLM on 2020/06/15
 * */

import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import selected_products from "./selected_products"

export default new Vuex.Store({
  modules: {
    selPro: selected_products,
  },
  state: {

    // 记录页面入口: 1-从"我家"进入; 2-从“易家整配进入”
    pageLevel: 2,

    // 上一个页面
    lastPath: undefined,

    // 是否是测试
    isTest: false,

    // 页面间通信对象 (页面间传值)
    pageParam: {},

    // 问卷内容
    surveyList: [
      {
        title: "您的新家是什么用途？",
        need: true,
        options: [
          { label: "刚需自住",  selected: false },
          { label: "投资出租",  selected: false }
        ]
      },
      {
        title: "你的房间需要配置什么功能？",
        need: true,
        options: [
          { label: "书房",  selected: false },
          { label: "工具房",  selected: false },
          { label: "宠物房",  selected: false },
          { label: "青少年房", selected: false },
          { label: "儿童房", selected: false },
          { label: "客房",  selected: false },
          { label: "健身房",  selected: false },
          { label: "储藏室",  selected: false },
          { label: "衣帽间",  selected: false },
          { label: "老人房",  selected: false }
        ]
      },
      {
        title: "您的新家计划居住几口人？",
        need: true,
        options: [
          { label: "单身贵族", selected: false },
          { label: "二人世界", selected: false },
          { label: "三口之家", selected: false },
          { label: "四口之家", selected: false },
          { label: "五口之家", selected: false },
          { label: "六口之家", selected: false },
          { label: "七口之家", selected: false },
          { label: "八口之家", selected: false },
          { label: "九口之家", selected: false },
          { label: "十全十美", selected: false }
        ]
      },
      {
        title: "您的新家要住几个孩子？",
        options: [
          { label: "独生子女", selected: false,icon:require('../assets/img/dushen_unselected.png'),active_icon:require('../assets/img/dushen_selected.png') },
          { label: "二胎家庭", selected: false,icon:require('../assets/img/ertai_unselected.png'),active_icon:require('../assets/img/ertai_selected.png')  },
          { label: "我有三胎", selected: false,icon:require('../assets/img/santai_unselected.png'),active_icon:require('../assets/img/santai_selected.png')  },
        ]
      },
      {
        title: "孩子是什么性别？",
        options: [
          { label: "男孩", selected: false,icon:require('../assets/img/boy.png'),active_icon:require('../assets/img/boy_selected.png') },
          { label: "女孩", selected: false,icon:require('../assets/img/girl.png'),active_icon:require('../assets/img/girl_selected.png') },
          { label: "有男有女", selected: false,icon:require('../assets/img/bouandgirl.png'),active_icon:require('../assets/img/bandg_selected.png') },
        ]
      },
      {
        title: "有其它家庭成员同住吗？",
        options: [
          { label: "与老人同住",  selected: false,icon:require('../assets/img/oldman_unselected.png'),active_icon:require('../assets/img/oldman_selected.png') },
          { label: "与客人同住",  selected: false,icon:require('../assets/img/kr_unselected.png'),active_icon:require('../assets/img/kr_selected.png') },
          { label: "与保姆同住",  selected: false,icon:require('../assets/img/bm_unselected.png'),active_icon:require('../assets/img/bm_selected.png')},
          { label: "与宠物同住",  selected: false,icon:require('../assets/img/cw_unselected.png'),active_icon:require('../assets/img/cw_selected.png') },
        ]
      },
    ],
  },
  getters:{

    // 是否从“我家”进入
    isFromMyHome: state => {
      return +state.pageLevel === 1
    },

  },
  mutations: {

    // 记录页面入口
    setPageLevel (state, n) {
      state.pageLevel = n
    },

    // 记录上一个URL地址
    setLastUrl(state, url){
      state.lastUrl = url
    },

    // 设置页面间参数
    setPageParam(state, data){
      state.pageParam = data
    },

    // 更新进入同一页面进的key值
    setRefreshKey(state, data){
      state.refreshKey += 1
    },

  }
})
